export default "# Install\n$ vue add @nklayman/capacitor\n\n# Usage\n$ yarn capacitor:serve\n";